import {
  type AuthAppSchema,
  type AuthAppSchemaWithIdNullable,
  httpDeleteAppsByAppId,
  httpGetApps,
  httpPostApps,
} from '@iconik-io/iconik-api/src/services/auth';

import type { AppDispatch } from '../../../store/types';
import {
  wrapCommonCreate,
  wrapCommonDelete,
  wrapCommonGetList,
} from '../../common_list/thunks';

type AppsListGetParams = {
  per_page?: number;
  last_id?: string;
};

export function getApps(params: AppsListGetParams = {}, debounce?: boolean) {
  return (dispatch: AppDispatch) =>
    wrapCommonGetList({
      prefix: 'admin_apps',
      params,
      dispatch,
      debounce,
      getListPromise: (listParams) => dispatch(httpGetApps(listParams)),
    });
}

export function createApp(data: AuthAppSchema) {
  return (dispatch: AppDispatch) =>
    wrapCommonCreate({
      prefix: 'admin_apps',
      dispatch,
      createPromise: dispatch(httpPostApps(data)),
    });
}

export function deleteAppsByIds(ids: string[]) {
  return (dispatch: AppDispatch): Promise<void> =>
    wrapCommonDelete({
      prefix: 'admin_apps',
      dispatch,
      ids,
      deletePromise: Promise.all(
        ids.map((id) => dispatch(httpDeleteAppsByAppId(id))),
      ),
    });
}

export function getAllApps() {
  return async (
    dispatch: AppDispatch,
  ): Promise<AuthAppSchemaWithIdNullable[]> => {
    let response = await dispatch(httpGetApps({ per_page: 100 }));
    let result = response.body.objects;
    while (response.body.objects.length > 0) {
      response = await dispatch(
        httpGetApps({ per_page: 100, last_id: result[result.length - 1].id }),
      );
      result = result.concat(response.body.objects);
    }
    return result;
  };
}
